import { FormattedMessage, useIntl } from "react-intl";

const AuditLogs = () => {
    const intl = useIntl();

    return (
        <div>
            <h2>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.content-modal.audit-logs.heading"
                    defaultMessage="Audit logs"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.content-modal.audit-logs.body"
                    defaultMessage="Audit logs let administrators look at changes made to your site. This is useful when you need to troubleshoot a problem or keep a record of important events, like changes to global permissions."
                />
            </p>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/audit-logs.cdnVersion1351.webp"
                alt={intl.formatMessage({
                    id: "JiraSoftwarePricingPage.content-modal.audit-logs.alt-text",
                    defaultMessage: "Example of audit logs"
                })}
                height="350px"
                loading="lazy"
            />
            <p>
                <FormattedMessage
                    id="JiraSoftwarePricingPage.content-modal.audit-logs.body2"
                    defaultMessage="Here's what audit logs look like in Jira."
                />
            </p>
        </div>
    );
};

export default AuditLogs;
